// extracted by mini-css-extract-plugin
export default {"controls":"milestone-carousel-module__controls___SVteZ","previous":"milestone-carousel-module__previous___jx3Qj","next":"milestone-carousel-module__next___GvpnJ"};